module.exports = __webpack_public_path__ + "img/arow_up.84219942.svg";